export default function(within) {
  switch (within) {
    case 'season':
      return within;
    default:
      return 'all';
  }
}



// WEBPACK FOOTER //
// ./src/lib/checkWithin.js